import DesignTokens from '@tableau/design-tokens';
import { cssRule } from 'typestyle';

import { applyColor }from '~src/style/ColorService';

cssRule('.tb-edit-connection-form', {
    display: 'table',
    width: '100%',
});

cssRule('.tb-edit-connection-form .tb-settings-group', {
    display: 'table-row',
});

cssRule('.tb-edit-connection-form .tb-form-label', {
    display: 'table-cell',
    verticalAlign: 'middle',
    textAlign: 'right',
    paddingRight: '12px',
    paddingBottom: '12px',
});

cssRule('.tb-edit-connection-form .tb-form-label.tb-form-label-tall', {
    verticalAlign: 'top',
    paddingTop: '1px',
});

cssRule('.tb-edit-connection-form .tb-form-value', {
    display: 'table-cell',
    paddingBottom: '12px',
});

cssRule('.tb-edit-connection-prompt', {
    marginBottom: '18px',
});

cssRule('.tb-edit-connection-sub-header', {
    fontWeight: 'bold',
    marginBottom: '12px',
});

cssRule('.tb-check-connection-result', {
    marginTop: '6px',
});

cssRule('.tb-edit-salesforce-connection-form .tb-edit-oauth-connection-option-label, .tb-edit-oauth-connection-form .tb-edit-oauth-connection-option-label', {
    marginBottom: '6px',
    display: 'block',
});

cssRule('.tb-edit-salesforce-connection-form .tb-invisible, .tb-edit-oauth-connection-form .tb-invisible', {
    visibility: 'hidden',
});

cssRule('.tb-edit-salesforce-connection-form .tb-edit-oauth-connection-option-contents, .tb-edit-oauth-connection-form .tb-edit-oauth-connection-option-contents', {
    marginLeft: '21px',
    marginBottom: '12px',
    display: 'inline-block',
});

cssRule('.tb-edit-salesforce-connection-form .tb-text-box-holder, .tb-edit-oauth-connection-form .tb-text-box-holder, .tb-edit-salesforce-connection-form .tb-select, .tb-edit-oauth-connection-form .tb-select', {
    width: '300px',
    marginBottom: '6px',
});

cssRule('.tb-edit-salesforce-connection-form .tb-select, .tb-edit-oauth-connection-form .tb-select', {
    display: 'inline-block',
});

cssRule('.tb-edit-salesforce-connection-form .tb-edit-oauth-connection-option-description, .tb-edit-oauth-connection-form .tb-edit-oauth-connection-option-description', {
    color: applyColor(DesignTokens.color.font.default.secondary, '#5c5c5c'),
});

